import { UserService } from "@/services";
export default {
  async loadIsamError({ commit }) {
    commit("SET_STATUS", 0);
    commit("SET_IS_FETCHING", true);
    try {
      await UserService.isamError().then(
        (res) => {
          commit("SET_STATUS", 1);
          const data = res?.data;
          commit("SET_RESPONSE", data);
          commit("SET_IS_FETCHING", false);
          return data;
        },
        (error) => {
          commit("SET_STATUS", 2);
          commit("SET_IS_FETCHING", false);
          console.error("err", error);
        }
      );
    } catch (e) {
      console.error(e);
      commit("SET_IS_FETCHING", false);
    }
  },
};
